<template>
  <div class="container experience-create">
    <div class="header">
      <el-breadcrumb class="breadcrumb"
                     separator="/">
        <el-breadcrumb-item>内容管理</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/article/list' }">信息资讯</el-breadcrumb-item>
        <el-breadcrumb-item>发布文章</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="content">
        <div class="left">
        </div>
        <div class="right">
          <el-button plain
                     @click="handleClose">取消</el-button>
          <el-button type="primary"
                     @click="handleSubmit">保存</el-button>
        </div>
      </div>
    </div>
    <div class="main">
      <h3 class="title">文章编辑</h3>
      <div class="content">
        <el-form :model="dataForm"
                 :rules="rules"
                 ref="dataForm"
                 label-width="130px"
                 class="dataForm left">
          <el-form-item label="文章标题："
                        prop="title">
            <el-input v-model="dataForm.title"
                      placeholder="输入文章标题"></el-input>
            <p class="tip">提示：最多可支持输入60个字符，30个中文字</p>
          </el-form-item>
          <el-form-item label="文章简介："
                        prop="description">
            <el-input v-model="dataForm.description"
                      placeholder="输入文章简介"
                      type="textarea"
                      :rows="2"></el-input>
          </el-form-item>
          <el-form-item label="来源："
                        prop="tags">
            <el-input v-model="dataForm.tags"
                      placeholder="请输入来源"></el-input>
          </el-form-item>
          <el-form-item label="文章分类："
                        prop="category_id">
            <el-select v-model="dataForm.category_id"
                       placeholder="请选择科目分类">
              <el-option v-for="item in categorys"
                         :key="item.id"
                         :label="item.name"
                         :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="适合科目："
                        prop="subjects">
            <div class="tag-wrap">
              <el-tag class="subject-item"
                      size="medium"
                      :key="item.id"
                      v-for="item in subjects"
                      closable
                      :disable-transitions="false"
                      @close="handleSubjectRemove(item)">
                {{item.college_name ? `${item.college_name}-${item.name}` : item.name}}
              </el-tag>
              <el-button type="text"
                         @click="handleSubjectChoose">选择科目</el-button>
            </div>
          </el-form-item>
          <el-form-item label="适合专业："
                        prop="majors">
            <div class="tag-wrap">
              <el-tag class="subject-item"
                      size="medium"
                      :key="item.id"
                      v-for="item in majors"
                      closable
                      :disable-transitions="false"
                      @close="handleMajorRemove(item)">
                {{`${item.name}/${item.code}`}}
              </el-tag>
              <el-button type="text"
                         @click="handleMajorChoose">选择专业</el-button>
            </div>
          </el-form-item>
          <el-form-item label="适合院校："
                        prop="colleges">
            <div class="tag-wrap">
              <el-tag class="subject-item"
                      size="medium"
                      :key="item.id"
                      v-for="item in colleges"
                      closable
                      :disable-transitions="false"
                      @close="handleCollegeRemove(item)">
                {{`${item.name}`}}
              </el-tag>
              <el-button type="text"
                         @click="handleCollegeChoose">选择院校</el-button>
            </div>
          </el-form-item>
          <div class="form-item-wrap">
            <el-form-item label="基础阅读量："
                          prop="virtual_pv">
              <el-input v-model="dataForm.virtual_pv"
                        placeholder="输入基础阅读量"></el-input>
            </el-form-item>
            <el-form-item label="基础点赞量："
                          prop="virtual_like_count">
              <el-input v-model="dataForm.virtual_like_count"
                        placeholder="输入基础点赞量"></el-input>
            </el-form-item>
          </div>
          <el-form-item label="发布状态："
                        prop="status">
            <el-switch v-model="dataForm.status"></el-switch>
          </el-form-item>
          <el-form-item label="发布人："
                        prop="author_id">
            <el-select v-model="dataForm.author_id"
                       filterable
                       remote
                       reserve-keyword
                       :remote-method="fetchAuthorList"
                       placeholder="搜索作者，选择保存"
                       style="width: 50%;">
              <el-option :label="`${item.realname}/${item.mobile}`"
                         :value="item.id"
                         v-for="item in authors"
                         :key="item.id"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div class="right">
          <el-upload class="upload-button"
                     drag
                     :action="imgUploadUrl"
                     :headers="uploadHeaders"
                     :show-file-list="false"
                     :on-success="handleUploadSuccess"
                     :before-upload="handleBeforeUpload">
            <div v-if="!dataForm.picture_url">
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">
                <p class="upload-text">将文件拖到此处，或<em>点击上传</em></p>
                <p class="el-upload-tip">支持扩展名：.jpg .jpge .png...</p>
                <!-- <p class="el-upload-tip">建议尺寸：900px*500px（和微信封面大小一致）</p> -->
              </div>
            </div>
            <div v-if="dataForm.picture_url">
              <el-image class="cover-selected"
                        :src="dataForm.picture_url"
                        fit="cover" />
            </div>
          </el-upload>
        </div>
      </div>
      <div class="editor-wrap">
        <UEeditor :setDataStr="dataForm.content"
                  @change="initDtaForm" />
      </div>
    </div>
    <SubjectChoose :visible="subjectChooseDialog"
                   :subjects="subjects"
                   @close="subjectChooseDialog = false"
                   @submit="saveSubject"></SubjectChoose>
    <MajorChoose :visible="majorChooseDialog"
                 :majors="majors"
                 @close="majorChooseDialog = false"
                 @submit="saveMajor"></MajorChoose>
    <CollegeChoose :visible="collegeChooseDialog"
                   :colleges="colleges"
                   @close="collegeChooseDialog = false"
                   @submit="saveCollege"></CollegeChoose>
  </div>
</template>

<script>
import SubjectChoose from '@/components/dialog/subject/SubjectChoose'
import MajorChoose from '@/components/dialog/major/MajorChoose'
import CollegeChoose from '@/components/dialog/college/CollegeChoose'
import { imgUploadUrl, uploadHeaders } from '@/config/index'
import { articleCreate, articleCategoryList } from '@/api/article'
import { seniorList } from '@/api/senior'
import UEeditor from '@/components/UEeditor'

export default {
  components: {
    SubjectChoose,
    MajorChoose,
    CollegeChoose,
    UEeditor,
  },
  data() {
    return {
      subjectChooseDialog: false,
      majorChooseDialog: false,
      collegeChooseDialog: false,
      imgUploadUrl: imgUploadUrl(),
      uploadHeaders: uploadHeaders(),

      dataForm: {
        picture_url: '',
        title: '',
        content: '',
        status: false,
      },
      subjects: [],
      majors: [],
      colleges: [],
      categorys: [],
      authors: [],
      rules: {
        title: [{ required: true, message: '请输入文章标题', trigger: 'blur' }],
        description: [
          { required: true, message: '请输入课程简介', trigger: 'blur' },
        ],
        // subjects: [
        //   { required: true, message: '请选择适合科目', trigger: 'change', validator: (rule, value, callback) => {
        //     if (!this.subjects.length) {
        //       return callback(new Error(rule.message))
        //     } else {
        //       callback()
        //     }
        //   }}
        // ],
        virtual_pv: [
          { required: true, message: '请输入基础阅读量', trigger: 'blur' },
        ],
        virtual_like_count: [
          { required: true, message: '请输入基础点赞量', trigger: 'blur' },
        ],
        content: [
          { required: true, message: '请输入文章内容', trigger: 'blur' },
        ],
        author_id: [
          { required: false, message: '请选择作者/学长', trigger: 'blur' },
        ],
        status: [
          { required: true, message: '请设置发布状态', trigger: 'blur' },
        ],
        category_id: [
          { required: true, message: '请选择文章分类', trigger: 'change' },
        ],
      },
    }
  },
  created() {
    this.fetchCategoryList()
  },
  mounted() {
    this.scrollToTop()
  },
  methods: {
    // 分类列表请求
    fetchCategoryList() {
      articleCategoryList({ isPaging: 0 }).then((res) => {
        this.categorys = res.list
      })
    },
    fetchAuthorList(name) {
      seniorList({ keyword: name, isPaging: 0 }).then((res) => {
        this.authors = res.list
      })
    },
    scrollToTop() {
      // Chrome
      document.body.scrollTop = 0
      // Firefox
      document.documentElement.scrollTop = 0
      // Safari
      window.pageYOffset = 0
    },
    handleSubjectClose(item) {},
    handleContentChange(editor) {
      this.dataForm.content = editor.html
    },
    handleSubjectRemove(item) {
      this.subjects = this.subjects.filter((v) => v.id !== item.id)
    },
    handleSubjectChoose() {
      this.subjectChooseDialog = true
    },
    saveSubject({ subjects }) {
      this.subjects = subjects
    },
    handleMajorRemove(item) {
      this.majors = this.majors.filter((v) => v.id !== item.id)
    },
    handleMajorChoose() {
      this.majorChooseDialog = true
    },
    saveMajor({ majors }) {
      this.majors = majors
    },
    handleCollegeRemove(item) {
      this.colleges = this.colleges.filter((v) => v.id !== item.id)
    },
    handleCollegeChoose() {
      this.collegeChooseDialog = true
    },
    saveCollege({ colleges }) {
      this.colleges = colleges
    },
    handleUploadSuccess(res, file) {
      if (res.code == 0 && res.data) {
        this.dataForm.picture_url = res.data.url
      } else {
        this.$message.error(res.error)
      }
    },
    handleBeforeUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 5

      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 5MB!')
      }
      return isLt2M
    },
    initDtaForm(e) {
      this.dataForm.content = e
    },
    handleSubmit() {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          /*     if (!this.dataForm.picture_url) {
                return this.$message.error(`请上传封面图`)
              } */
          if (!this.dataForm.content) {
            return this.$message.error(`请输入文章内容`)
          }
          let params = Object.assign({}, this.dataForm, {
            subjects: this.subjects.map((item) => ({
              code: item.code,
              college_code: item.college_code,
            })),
            majors: this.majors.map((item) => ({
              code: item.code,
              college_code: item.college_code,
            })),
            colleges: this.colleges.map((item) => ({ code: item.code })),
          })
          params.status = params.status ? 1 : 0
          articleCreate(params)
            .then((res) => {
              this.$message.success(`创建成功`)
              this.$refs['dataForm'].resetFields()

              this.$router.go(-1)
            })
            .catch((error) => {
              console.log('error: ', error)
            })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    handleClose() {
      this.$router.go(-1)
    },
  },
}
</script>

<style scoped lang="less">
.experience-create {
  .header {
    background: #fff;
    padding: 20px;

    .breadcrumb {
      margin-bottom: 20px;
    }
    .content {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
  }
  .main {
    background: #fff;
    padding: 20px;
    margin-top: 10px;

    .title {
      font-size: 32px;
      font-weight: bold;
    }
  }
  .main .content {
    display: flex;
    margin-top: 20px;

    .left,
    .right {
      flex: 1;
    }
    .left {
      padding-right: 20px;
    }
    .form-item-wrap {
      display: flex;

      /deep/ .el-input {
        width: 150px;
      }
    }
    .upload-button {
      width: 100%;

      /deep/ .el-upload {
        width: 100%;
      }
      /deep/ .el-upload-dragger {
        width: 100%;
        height: 220px;
      }
      .el-upload-tip {
        font-size: 12px;
        color: #606266;
        margin-top: 7px;
      }
      .upload-text {
        margin-bottom: 10px;

        /*   &:before {
          content: "*";
          color: #f56c6c;
          margin-right: 4px;
        } */
      }
    }
    .tag-wrap {
      display: flex;
      flex-wrap: wrap;
    }
    .subject-item {
      margin-right: 5px;
      margin-bottom: 5px;
    }
  }
  .editor-wrap {
    position: relative;
    color: #303133;
    background-color: #fff;
    border: 1px solid #ebeef5;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    overflow: hidden;
    padding: 20px;
    margin-top: 20px;
  }
}
</style>
